'use strict';

const Mn = require('backbone.marionette');
const GroupPermission = require('common/domain/entity/group-permission');
const GroupEditTemplate = require('balus/ui/template/body/group-role/content/permission/group-edit.hbs');
const ProjectCreateTemplate = require('balus/ui/template/body/group-role/content/permission/project-create.hbs');
const NotParticipatedProjectViewTemplate = require('balus/ui/template/body/group-role/content/permission/not-participated-project-view.hbs');
const Template = require('balus/ui/template/body/group-role/content/index.hbs');

const GroupEditView = Mn.View.extend({
    template: GroupEditTemplate
});

const ProjectCreateView = Mn.View.extend({
    template: ProjectCreateTemplate
});

const NotParticipatedProjectViewView = Mn.View.extend({
    template: NotParticipatedProjectViewTemplate
});

module.exports = Mn.View.extend({
    regions: {
        groupEdit: '.group-edit',
        projectCreate: '.project-create',
        notParticipatedProjectView: '.not-participated-project-view'
    },
    template: Template,

    onRender: function() {
        const getPermission = klass => {
            return this.model.getPermissions().find(
                p => p instanceof klass);
        };

        this.showChildView('groupEdit', new GroupEditView({
            model: getPermission(GroupPermission.GroupEditPermission)
        }));
        this.showChildView('projectCreate', new ProjectCreateView({
            model: getPermission(GroupPermission.ProjectCreatePermission)
        }));
        this.showChildView('notParticipatedProjectView', new NotParticipatedProjectViewView({
            model: getPermission(GroupPermission.NotParticipatedProjectViewPermission)
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/group-role/content/index.js